export const parseLabel = (name: string) => {
    const label = name.replace(/__/g, '-').replace(/_/g, ' ')
    return label
}
